import { render, staticRenderFns } from "./RepuestosRecibidosBodega.vue?vue&type=template&id=274adee7&scoped=true&lang=pug"
import script from "./RepuestosRecibidosBodega.vue?vue&type=script&lang=js"
export * from "./RepuestosRecibidosBodega.vue?vue&type=script&lang=js"
import style0 from "./RepuestosRecibidosBodega.vue?vue&type=style&index=0&id=274adee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274adee7",
  null
  
)

export default component.exports